// extracted by mini-css-extract-plugin
export var label = "_ch-1";
export var reminder = "_ch-0";